import { render, staticRenderFns } from "./UploadUsers.vue?vue&type=template&id=1b2caae9&scoped=true"
import script from "./UploadUsers.vue?vue&type=script&lang=js"
export * from "./UploadUsers.vue?vue&type=script&lang=js"
import style0 from "./UploadUsers.vue?vue&type=style&index=0&id=1b2caae9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2caae9",
  null
  
)

export default component.exports